import React, { useEffect } from 'react'
import bgstars from '@/shared/assets/topbgstars.webp'
import { ContactForm } from '@/shared/ui/ContactForm/ContactForm'
import telegram from '@/shared/assets/telegram.svg'
import whatsapp from '@/shared/assets/whatsapp.svg'
import linkedin from '@/shared/assets/linkedin.svg'
import { classNames } from '@/shared/utils/classNames'
import cls from './Main.module.scss'
import smartapp from '@/shared/assets/smartapp_r1.webp'

export const Main = () => {
    useEffect(() => {
        const isAndroid = /Android/i.test(
            navigator.userAgent
        )
        if (isAndroid && window.location.search === '') {
            window.location.href =
                '/open?referrer=0000000000000000'
        }
    }, [])

    return (
        <main className={cls.Main}>
            <img
                className={cls.BGImage}
                src={bgstars}
                alt="star"
            />
            <article className={cls.title}>
                <h1>Stellar Bets</h1>
                <p>Start Your Gaming Business with</p>
            </article>
            <img
                src={smartapp}
                className={cls.smartImage}
                alt="im"
            />
            <article className={cls.links}>
                <a
                    className={cls.getApp}
                    href="https://hp.stellar-bets.com/"
                >
                    Open Wep App
                </a>

                <a
                    className={cls.Telegram}
                    href="https://t.me/stellar_bets"
                >
                    <img
                        src={telegram}
                        className={classNames(cls.Ico, [
                            cls.tg,
                        ])}
                        alt="ico"
                    />
                    Telegram
                </a>
                <a
                    className={cls.WhatsApp}
                    href="https://chat.whatsapp.com/I6TfHQ2uqSBLuCw6zW6eO5"
                    alt="ico"
                >
                    <img
                        src={whatsapp}
                        className={classNames(cls.Ico, [
                            cls.wa,
                        ])}
                    />
                    WhatsApp
                </a>

                <a
                    className={cls.LinkedIn}
                    href="https://www.linkedin.com/company/stellarbets/"
                >
                    <img
                        src={linkedin}
                        className={classNames(cls.Ico, [
                            cls.in,
                        ])}
                        alt="ico"
                    />
                    LinkedIn
                </a>
            </article>
            {/* <ContactForm /> */}
        </main>
    )
}
